
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function BottomNav({ activeTab, setActiveTab, role }) {
  const { t, i18n } = useTranslation();
  
  // Re-create tabs when language changes
  const tabs = useMemo(() => {
    if (role === 'business') {
      return [
        { id: 'home', label: t('nav.home'), icon: '🏠' },
        { id: 'sub-accounts', label: t('nav.subAccounts'), icon: '🏢' },
        { id: 'transactions', label: t('nav.history'), icon: '📊' },
        { id: 'settings', label: t('nav.settings'), icon: '⚙️' },
        { id: 'profile', label: t('nav.profile'), icon: '👤' }
      ];
    }
    const baseTabs = role === 'mobpay' 
      ? [
          { id: 'home', label: t('nav.home'), icon: '🏠' },
          { id: 'history', label: t('nav.history'), icon: '📊' },
          { id: 'tools', label: t('nav.tools'), icon: '🧩' },
          { id: 'settings', label: t('nav.settings'), icon: '⚙️' },
          { id: 'profile', label: t('nav.profile'), icon: '👤' }
        ]
      : [
          { id: 'home', label: t('nav.home'), icon: '🏠' },
          { id: 'contacts', label: t('nav.contacts'), icon: '👥' },
          { id: 'history', label: t('nav.history'), icon: '📊' },
          { id: 'tools', label: t('nav.tools'), icon: '🧩' },
          { id: 'settings', label: t('nav.settings'), icon: '⚙️' },
          { id: 'profile', label: t('nav.profile'), icon: '👤' }
        ];
    return baseTabs;
  }, [role, t, i18n.language]);
  
  return (
    <div
      className="fixed bottom-0 left-0 right-0 bg-white border-t shadow-lg z-50"
      style={{
        paddingBottom: 'calc(env(safe-area-inset-bottom) + 16px)',
        height: 'calc(72px + env(safe-area-inset-bottom))'
      }}
      data-testid="bottom-nav"
    >
      <div className="flex justify-around items-center h-full">
        {tabs.map(tab => (
          <button
            key={tab.id}
            data-testid={`tab-${tab.id}`}
            onClick={() => setActiveTab(tab.id)}
            className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
              activeTab === tab.id ? 'text-blue-600' : 'text-gray-600'
            }`}
          >
            <span className="text-xl mb-1">{tab.icon}</span>
            <span className="text-xs">{tab.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
